import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { withOpsBase } from "@/lib/opsBase";

export default function DriverRedirect() {
  const { code } = useParams();

  useEffect(() => {
    if (!code) return;

    fetch(`/api/d/${code}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.redirect_url) {
          window.location.href = data.redirect_url;
        } else {
          window.location.href = `${withOpsBase("/dd/hub")}?error=invalid`;
        }
      })
      .catch(() => {
        window.location.href = `${withOpsBase("/dd/hub")}?error=fetch`;
      });
  }, [code]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#FBF8F1",
        fontFamily: "sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            width: 48,
            height: 48,
            border: "4px solid #EBB3A9",
            borderTopColor: "#EE2677",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 16px",
          }}
        />
        <p style={{ color: "#2D2D2D", fontSize: 16 }}>Loading...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
